module.exports = function () {
    $(document).ready(function () {

        // var AjaxController = require('./services/AjaxController');
        //
        // var typeSelect = $('#type');
        // var categorySelect = $('#category');
        //
        // categorySelect.on('select', function(){
        //
        //     var url = '/api/properties/expenditures/getTypesForCategory';
        //     var data = { category: $(this).find('option :selected').val() };
        //     var success = function(response) {
        //         console.log("I've got those types!")
        //     }
        //     var error = function(response) {
        //         console.log('Error')
        //     }
        //
        //     /* Send AJAX request */
        //     AjaxController.prototype.send(url, data, success, error);
        // });

    });
}();